import { render, staticRenderFns } from "./SaleEditButtonVisibility.vue?vue&type=template&id=c33f0e7c&scoped=true"
import script from "./SaleEditButtonVisibility.vue?vue&type=script&lang=ts"
export * from "./SaleEditButtonVisibility.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33f0e7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c33f0e7c')) {
      api.createRecord('c33f0e7c', component.options)
    } else {
      api.reload('c33f0e7c', component.options)
    }
    module.hot.accept("./SaleEditButtonVisibility.vue?vue&type=template&id=c33f0e7c&scoped=true", function () {
      api.rerender('c33f0e7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-sales/SaleEditButtonVisibility.vue"
export default component.exports